export const integerFormatter = (row, cell, value, columnDef, dataContext) =>
    value ? parseFloat(value).toLocaleString("en-AU") : null;
export const currencyFormatter = (row, cell, value, columnDef, dataContext) =>
    value !== null && value !== undefined ? "$" + parseFloat(value).toLocaleString("en-AU") : null;
export const currency3Formatter = (row, cell, value, columnDef, dataContext) =>
    value !== null && value !== undefined ? "$" + parseFloat(value).toLocaleString("en-AU", { minimumFractionDigits: 3, maximumFractionDigits: 3 }) : null;
export const decimal0Formatter = (row, cell, value, columnDef, dataContext) =>
    value ? parseFloat(value).toFixed(0) : null;
export const decimal1Formatter = (row, cell, value, columnDef, dataContext) =>
    value ? parseFloat(value).toFixed(1) : null;
export const decimal2Formatter = (row, cell, value, columnDef, dataContext) =>
    value ? parseFloat(value).toFixed(2) : null;
export const decimal3Formatter = (row, cell, value, columnDef, dataContext) =>
    value ? parseFloat(value).toFixed(3) : null;
export const percent1Formatter = (row, cell, value, columnDef, dataContext) =>
    value ? parseFloat(value).toFixed(1) + "%" : null;
export const percent2Formatter = (row, cell, value, columnDef, dataContext) =>
    value ? parseFloat(value).toFixed(2) + "%" : null;
export const percent3Formatter = (row, cell, value, columnDef, dataContext) =>
    value ? parseFloat(value).toFixed(3) + "%" : null;
export const dateFormatter = (row, cell, value, columnDef, dataContext) =>
    value ? new Date(value).toISOString().split("T")[0] : null;
export const volume500kFormatter = (row, cell, value, columnDef, dataContext) =>
    value && value > 0 ? "Yes - " + value.toLocaleString() : "No - 0";
export const isinFormatter = (row, cell, value, columnDef, dataContext) =>
    (dataContext && dataContext._isTotals)
      ? (value || null)
      : (value ? `<a href="/securities/${value.toLowerCase()}" class="text-secondary underline" data-turbo-frame="_top">${value}</a>` : null);

// Wrapper function to add link to any formatter's output
export const withLinkWrapper = (originalFormatter) => {
  return (row, cell, value, columnDef, dataContext) => {
    const formattedContent = originalFormatter ? originalFormatter(row, cell, value, columnDef, dataContext) : value;

    // If the content is already a link, return it as-is
    if (formattedContent && formattedContent.includes('<a href=')) {
      return formattedContent;
    }

    // If there's content, wrap it in a link
    if (formattedContent) {
      return `<a href="/securities/${dataContext.id}" class="text-secondary underline" data-turbo-frame="_top">${formattedContent}</a>`;
    }

    return formattedContent;
  };
};

// Simple link formatter for columns without existing formatters
export const simpleLinkFormatter = (row, cell, value, columnDef, dataContext) =>
    value ? `<a href="/securities/${dataContext.id}" class="text-secondary underline" data-turbo-frame="_top">${value}</a>` : null;
